import { PaginationState } from '@tanstack/react-table';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { SourceUrlStatsDto } from '@/Domain/api/Analytics/dto/SourceUrl.dto';
import { SourceUrlsTable } from '@/Domain/components/Insights/SourceUrls/SourceUrlsTable';
import { Card, CardDescription, CardHeader, CardTitle } from '@/Domain/components/Shared/Card/Card';

type Props = {
  isError: boolean;
  isLoading: boolean;
  isPlaceholderData: boolean;
  data: SourceUrlStatsDto | undefined;
  pagination: PaginationState;
  setPagination: Dispatch<SetStateAction<PaginationState>>;
};

export const SourceUrlsSection = ({
  isError,
  isLoading,
  isPlaceholderData,
  data,
  pagination,
  setPagination,
}: Props) => {
  const { t } = useTranslation('insights_page', { keyPrefix: 'ai_insights.source_urls' });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
        <CardDescription>{t('description')}</CardDescription>
      </CardHeader>
      <SourceUrlsTable
        isError={isError}
        isLoading={isLoading}
        isPlaceholderData={isPlaceholderData}
        data={data}
        pagination={pagination}
        setPagination={setPagination}
      />
    </Card>
  );
};
